import React from 'react';
import type EditWorkflow from '@atlassian/jira-admin-pages-edit-workflow/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyEditWorkflow = lazyForPaint<typeof EditWorkflow>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-edit-workflow", jiraSpaEntry: "async-admin-pages-edit-workflow" */ '@atlassian/jira-admin-pages-edit-workflow'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyEditWorkflow} pageId="jira-admin-pages-edit-workflow" shouldShowSpinner />
);
